export const CenterActions = {
    handleCpr: (id: number) => {
        window.open(`center/${id}/reports/my-center/fcr-score-audit-report`);
    },
    handlePairs: (id: number) => {
        window.location.href = `/center/${id}/recipients`;
    },
    handleLogin: (id: number) => {
        window.open(`center/${id}`);
    },
    handleEdit: (id: number) => {
        window.location.href = `/center/${id}/profile/edit`;
    },
    handleContacts: (id: number) => {
        window.location.href = `/contacts?centerId=${id}`;
    },
    handleActionCenter: (id: number) => {
        window.open(`/center/${id}`);
    },
    handleAccountPlan: (id: number) => {
        window.location.href = `/admin/center/${id}/account-plan`;
    }
}